import React, { Component } from "react";
import { Link } from "react-router-dom";

import "react-bootstrap";

import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../../api/apiConstant";
import { Businesses } from "../../../config/Helper";
import logApi from "../../../api/logApi";
class ServiceBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.business = Businesses.indexOf("service");
    this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.props.media_type === 0) {
      window.checkSize();
    }

    setTimeout(this.ellipsisStyle, 400);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentDidUpdate() {
    if (
      this.props.media_type === 0 &&
      this.props.image !== undefined &&
      this.props.image !== null
    ) {
      window.checkSize();
    }
    setTimeout(this.ellipsisStyle, 400);
  }

  componentWillReceiveProps(newProps) {}

  onErrorImageLoad() {
    $("#img_" + this.props.id).attr("src", "/assets/images/no_image.png");
  }

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#service_" + this.props.type + "_" + this.props.id);
  }

  render() {
    var imageName = "";
    if (
      this.props.image !== undefined &&
      this.props.image !== null &&
      this.props.media_type === 1
    ) {
      var name_without_extention = this.props.image.slice(
        0,
        this.props.image.length - 4
      );
      imageName = name_without_extention + ".jpg";
    }

    var popupClass = "service-image";
    if (this.props.media_type === 1) {
      popupClass = "play-video";
    }
    return (
      <div className="col-md-6 col-lg-4 ftco-animate fadeIn ftco-animated">
        <div className="project">
          <Link to={"/service/" + this.props.id}>
            <div className="img">
              {(this.props.image === undefined ||
                this.props.image === null) && (
                <img
                  src="/assets/images/no_image.png"
                  className="img-fluid"
                  alt="service-block-no"
                />
              )}
              {this.props.media_type === 0 && (
                <img
                  id={`img_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src=""
                  data-desktop-image={apiConstant.thumbnail(
                    this.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-tablet-image={apiConstant.tablet(
                    this.business,
                    this.props.id,
                    this.props.image
                  )}
                  data-mobile-image={apiConstant.mobile(
                    this.business,
                    this.props.id,
                    this.props.image
                  )}
                  className="img-fluid"
                  alt="service-block-photo"
                />
              )}
              {this.props.media_type === 1 && (
                <div>
                  <img
                    id={`img_${this.props.id}`}
                    onError={() => this.onErrorImageLoad()}
                    src={apiConstant.thumbnail(
                      this.business,
                      this.props.id,
                      imageName
                    )}
                    className="img-fluid"
                    alt="service-block-video"
                  />
                </div>
              )}
            </div>
          </Link>
          {this.props.media_type === 1 && (
            <a
              href={apiConstant.desktop(
                this.business,
                this.props.id,
                this.props.image
              )}
              className="play-video video-icon"
              onClick={() =>
                logApi.log({
                  title: this.props.title,
                  lang: localStorage.getItem("language"),
                  type: "동화상",
                })
              }
            >
              <i className="fa fa-play" aria-hidden="true"></i>
            </a>
          )}
          <div className="text">
            <Link to={"/service/" + this.props.id}>
              <h3
                className="ellipsis"
                id={`service_${this.props.type}_${this.props.id}`}
                caption={this.props.title}
                dangerouslySetInnerHTML={{ __html: this.props.title }}
              />
            </Link>
          </div>
          {/* {this.props.media_type !== 1 && (
            <a
              href={apiConstant.desktop(
                this.business,
                this.props.id,
                this.props.image
              )}
              data-lightbox="gallery-item"
              className={
                "icon d-flex justify-content-center align-items-center " +
                popupClass
              }
              caption={this.props.title}
            >
              <span className="icon-expand"></span>
            </a>
          )} */}
        </div>
      </div>
    );
  }
}

export default ServiceBlock;
